// Read function

export const getRequiredLord = async (nftStakingContract) => {
  return await nftStakingContract.requiredLord();
};

export const getWithdrawalFeesPercentage = async (nftStakingContract) => {
  return await nftStakingContract.withdrawalFeesPercentage();
};

export const getLordBurnPercentage = async (nftStakingContract) => {
  return await nftStakingContract.lordBurnPercentage();
};

export const getStakers = async (nftStakingContract, userAddress) => {
  return await nftStakingContract.stakers(userAddress);
};

export const getStakedTokens = async (nftStakingContract, userAddress) => {
  return await nftStakingContract.getActiveStakedNFTs(userAddress);
};

export const getMetaspaceBaseApiURL = async (nftStakingContract) => {
  return await nftStakingContract.metaspaceBaseApiURL();
};

export const decodeData = async (nftStakingContract, data) => {
  return await nftStakingContract.decodeData(data);
};

export const isApprovedForAll = async (
  nftContract,
  userAddress,
  nftStakingaddress
) => {
  return await nftContract.isApprovedForAll(userAddress, nftStakingaddress);
};

export const getTokenOfOwnerByIndex = async (
  nftContract,
  userAddress,
  index
) => {
  return await nftContract.tokenOfOwnerByIndex(userAddress, index);
};

export const nftApprove = async (nftContract, nftStakingaddress) => {
  const answer = await nftContract.setApprovalForAll(nftStakingaddress, true);
  // console.log("answer", answer);
  return answer;
};

// Write function

export const setStake = async (nftStakingContract, nftAddress, tokenID) => {
  const tx = await nftStakingContract.stake(nftAddress, tokenID);
  const rec = await tx.wait();
  return rec;
};

export const setWithdraw = async (nftStakingContract, nftAddress, tokenID) => {
  // console.log(nftStakingContract, nftAddress, tokenID, "nftinfo");
  const tx = await nftStakingContract.withdraw(nftAddress, tokenID);
  const rec = await tx.wait();
  return rec;
};

export const setClaimRewards = async (nftStakingContract) => {
  const tx = await nftStakingContract.claimRewards();
  const rec = await tx.wait();
  return rec;
};
